export default function AMESRouteControls() {

    return <></>
}